// flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { User } from '../../types'
import { fetchAlerts, deleteAlert } from '../../actions/user'
import Table from '../../components/Table'
import Tr from '../../components/Tr'
import Th from '../../components/Th'
import Button from '../../components/Button'
import Blockquote from '../../components/Blockquote'
import AlertRow from './components/AlertRow'
import AlertModalForm from '../../components/AlertFormModal'

type Props = {
  user: User,
  deleteAlert: Function,
  fetchAlerts: Function,
  alerts: Array<Object>
}

type State = {
  alertFormModalOpen: boolean,
  editingAlert: Object | null
}

const newAlertInitialValues = {
  minprice: 0,
  minbeds: 0,
  minbaths: 0,
  minarea: 0
}

class UserSearches extends Component {
  constructor(props: Props) {
    super(props)
    this.state = {
      alertFormModalOpen: false,
      editingAlert: null
    }
  }

  state: State

  componentDidMount() {
    this.props.fetchAlerts(this.props.user.id)
  }

  props: Props

  handleOpenEditModal = (alert) => {
    this.setState({ editingAlert: alert, alertFormModalOpen: true })
  }

  handleDelete = (alert) => {
    this.props.deleteAlert(this.props.user.id, alert.id)
  }

  handleNewAlertClick = () => {
    this.setState({ editingAlert: null, alertFormModalOpen: true })
  }

  render() {
    return (
      <div>
        <Helmet title="Searches" />
        <Blockquote style={{ marginBottom: '2rem' }}>
          Your saved searches are used to send notifications when new properties
          hit the market.
        </Blockquote>
        <Table>
          <thead>
            <Tr>
              <Th>Keyword</Th>
              <Th>Price</Th>
              <Th>Beds</Th>
              <Th>Baths</Th>
              <Th>Square feet</Th>
              <Th />
            </Tr>
          </thead>
          <tbody>
            {this.props.alerts.map((alert) => (
              <AlertRow
                key={alert.id}
                alert={alert}
                onDelete={this.handleDelete}
                onOpenEditModal={this.handleOpenEditModal}
              />
            ))}
          </tbody>
        </Table>
        <div>
          <Button
            color="primary"
            type="button"
            onClick={this.handleNewAlertClick}
          >
            Add new
          </Button>
        </div>
        <AlertModalForm
          user={this.props.user}
          alert={this.state.editingAlert}
          isOpen={this.state.alertFormModalOpen}
          initialValues={this.state.editingAlert || newAlertInitialValues}
          onRequestClose={() => {
            this.setState({ alertFormModalOpen: false })
          }}
        />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.session.currentUser,
    alerts: state.user.alerts
  }),
  {
    fetchAlerts,
    deleteAlert
  }
)(UserSearches)



// WEBPACK FOOTER //
// ./src/views/UserSearches/index.js